import { useMemo } from 'react';
import { CAP_TABLE_CURRENCY_PAGE } from 'common/constants/currencyPageTypes';
import { useFormat } from 'common/hooks';
import { CustomScalarSpreadsheet } from 'components';
import { REGULAR_UNIT } from 'components/FeaturedSpreadsheet/constants';
import { BacksolveTableProps } from './types';

const BacksolveTable = ({
  deleteColFn,
  isLedgerTable,
  isLoading,
  onChange,
  spreadsheets,
  workbook,
}: BacksolveTableProps) => {
  const { backsolveSheet } = spreadsheets;

  const [format] = useFormat({ page: CAP_TABLE_CURRENCY_PAGE, units: REGULAR_UNIT });

  const backsolveSheetProps = useMemo(
    () => ({
      ...backsolveSheet,
      id: 'backsolve-table',
      tableTerms: { tableSlug: 'backsolve-table' },
      workbook,
      onChange,
      sheet: backsolveSheet,
      displayLegend: false,
      alwaysDisplayLegend: false,
      format,
      deleteColumn: deleteColFn,
      isLedgerTable,
    }),
    [backsolveSheet, deleteColFn, format, isLedgerTable, onChange, workbook]
  );

  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: ScalarSpreadsheet is not typed
    <CustomScalarSpreadsheet {...backsolveSheetProps} isLoading={isLoading} />
  );
};

export default BacksolveTable;
